import { render } from "./ListViewDestination.vue?vue&type=template&id=53b6361d&scoped=true"
import script from "./ListViewDestination.vue?vue&type=script&lang=js"
export * from "./ListViewDestination.vue?vue&type=script&lang=js"

import "./ListViewDestination.vue?vue&type=style&index=0&id=53b6361d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53b6361d"

export default script